<template>
    <b-modal
        :hide-header="hideHeader"
        footer-class="p-2 border-top-0"
        :id="id"
        :title="title"
        :cancel-title="$t(cancelText)"
        :ok-only="isOkOnly"
        :ok-title="$t(okText)"
        @ok="onOkPressed"
    >
        <Paragraph> {{ $t(text, context) }} </Paragraph>
    </b-modal>
</template>

<script>
import Paragraph from "@/components/html/Paragraph";
export default {
    name: "Modal",
    components: {Paragraph},
    props: {
        id: {
            type: String,
            required: true,
        },
        text: {
            type: String,
            required: true
        },
        title: {
            type: String,
            default: process.env.VUE_APP_NAME,
        },
        hideHeader: {
            type: Boolean,
            default: true
        },
        context: {
            default: () => {},
        },
        onOkPressed: {
            type: Function,
            default: () => {},
        },
        isOkOnly: {
            type: Boolean,
            default: true
        },
        okText: {
            type: String,
            default: 'ok'
        },
        cancelText: {
            type: String,
            default: 'no'
        }
    }
}
</script>

<style scoped>

</style>